export default __webpack_public_path__ + "static/media/tiltbox.8e7a59b7.svg";